import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import benefitBeach from "../../assets/images/new/04.jpg";
import benefitCruise from "../../assets/images/new/5.jpg";
import benefitResort from "../../assets/images/new/7.jpg";

import "./benefits.css";

const Benefits = () => {
  return (
    <>
      {/* HEADER */}
      <section className="benefits_header">
        <Container>
          <Row>
            <Col md={12} className="text-center">
              <h1 className="benefits_title">
                Exclusive Benefits with BR Travel
              </h1>
              <p className="benefits_subtitle">
                Travel experiences crafted for comfort, luxury, and unforgettable
                memories.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* BENEFIT 1 */}
      <section className="benefit_block">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <div className="benefit_img">
                <img src={benefitBeach} alt="Sun-Kissed Beach" />
              </div>
            </Col>
            <Col md={6}>
              <h2 className="benefit_heading">
                Relaxing Beach & Coastal Escapes
              </h2>
              <p className="benefit_text">
                Enjoy serene ocean views, premium beachfront stays, and curated
                activities that let you unwind at your own pace. BR Travel takes
                care of the details so your beach vacation feels effortless and
                memorable.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* BENEFIT 2 */}
      <section className="benefit_block alt_bg">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <h2 className="benefit_heading">
                Curated Cruise Journeys
              </h2>
              <p className="benefit_text">
                Set sail on exceptional cruise experiences that combine
                magnificent destinations with luxury and comfort. From
                unforgettable island stops to world-class service on the water,
                cruise vacations with BR Travel redefine adventure.
              </p>
            </Col>
            <Col md={6}>
              <div className="benefit_img">
                <img src={benefitCruise} alt="Premium Cruises" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* BENEFIT 3 */}
      <section className="benefit_block">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <div className="benefit_img">
                <img src={benefitResort} alt="Luxury Resorts" />
              </div>
            </Col>
            <Col md={6}>
              <h2 className="benefit_heading">
                Premium Resort & City Stays
              </h2>
              <p className="benefit_text">
                Discover lush resorts and vibrant city escapes with exclusive
                access, tailored stays, and experiences designed for every
                traveler. Whether it’s a peaceful getaway or a cultural journey,
                we’ve got you covered.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CALL TO ACTION */}
      <section className="benefits_cta">
        <Container>
          <Row className="text-center">
            <Col md={12}>
              <h2>Ready to Elevate Your Travel?</h2>
              <p>
                Join BR Travel and experience journeys that stay with you long
                after the trip ends.
              </p>
              <a href="/contact" className="cta_btn">
                Contact Us
              </a>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Benefits;
